module.exports = __webpack_public_path__ + "img/portal-no-samp.74ceb4fe.jpg";